<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
        <el-form :model="form">
            <el-form-item label="银行名称" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off" placeholder="请输入银行名称"></el-input>
            </el-form-item>
            <el-form-item label="选择图片" :label-width="formLabelWidth">
                <div class="chooseImg" @click="chooseImg"><i class="el-icon-plus" v-if="!imaPath"></i>
                    <img v-else :src="imaPath" mode="scaleToFill" />
                </div>
            </el-form-item>
            <el-form-item label="排序（数字越小越靠前）" :label-width="formLabelWidth">
                <el-input v-model="form.sort" autocomplete="off" placeholder="请输入内容"></el-input>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="addBank">确 定</el-button>
        </div>
        <Upload v-if="isProductUpload" :isupload="isProductUpload" :config="selectorConfig" @returnImgs="handleReturnImgs">
        </Upload>
    </el-dialog>
</template>
<script>
import bankApi from '@/api/setting/bank.js';
import Upload from '@/components/file/Upload';
export default {
    components: {
        Upload
    },
    props: ['message', 'itemList'],
    data() {
        return {
            dialogFormVisible: false,
            form: {
                name: '', // 银行名称
                // imageUrl: '', // 图片地址
                sort: '', // 排序方式
            },
            formLabelWidth: '160px',
            // isupload: false, /*是否打开图片选择*/
            isProductUpload: false,
            selectorConfig: {
                total: 3,
                fileType: "image",
            },
            imaPath: '',
            imageId: '',
            id: null,
            title: '新增银行',
        }
    },
    methods: {
        /*上传商品图片*/
        chooseImg() {
            this.isProductUpload = true
        },
        handleReturnImgs(imgList) {
            if (imgList) {
                // 用户选择了图片，处理返回的图片列表
                // console.log(imgList)
                // console.log(imgList[0]);
                this.imaPath = imgList[0].filePath;
                this.imageId = imgList[0].fileId;
                this.isProductUpload = false;
            } else {
                // 用户取消了选择
                // console.log("用户取消了选择");
                this.isProductUpload = false;
                // console.log(this.isProductUpload)
            }
        },
        // 关闭组件
        handleCancel() {
            this.form.name = '';
            this.form.sort = '';;
            this.imaPath = '';
            this.imageId = '';
            this.id = null;
            this.dialogFormVisible = false
            this.$emit('closeFunction', this.dialogFormVisible) // 传递数据给父组件
        },
        // 确定（新增）
        addBank() {
            const name = this.form.name;
            const sort = this.form.sort;
            const imageId = this.imageId;
            const id = this.id;
            // 新增 请求
            bankApi.getAddBank({ name: name, sort: sort, imageId: imageId, id: id }).then(response => {
                // console.log(response);
                if (this.id == null) {
                    this.$message({
                        message: '新增成功',
                        type: 'success'
                    });
                } else {
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    });
                }
                this.$emit('add-success');
            }).catch(error => {
                // console.error(error);
            });
            // 清空表单数据
            this.handleCancel();
        }
    },
    watch: {
        message(newVal) {
            this.dialogFormVisible = newVal // 监视 props 的变化，将值赋给子组件的 data 属性
        },
        itemList(newVal, oldVal) {
            if (newVal) {
                this.form.name = newVal.name
                this.form.sort = newVal.sort
                this.imaPath = newVal.imageUrl
                this.id = newVal.id
                this.title = '编辑银行'
            } else {
                this.title = '新增银行'
            }
        }
    },
}
</script>

<style scoped lang="scss"> .chooseImg {
     width: 110px;
     height: 110px;
     display: flex;
     justify-content: center;
     align-items: center;
     border: 1px dashed #dddddd;
     font-size: 30px;
     overflow: hidden;

     img {
         width: 100%;
     }
 }
</style>


// WEBPACK FOOTER //
// src/views/setting/bank/components/AddView.vue